import { useUpdateMembership } from '@occc-app/dataAccessLayer/membership/mutations';
import { MembershipFragment, Membership_Type } from '@occc/graphql';

import { MemberTypeDropdown } from './MemberTypeDropdown';

type MemberEmployeeStatusProps = {
  member: MembershipFragment;
  isUserPermittedToUpdateMemberType: boolean;
};

export const MemberTypeDropdownContainer = ({
  member,
  isUserPermittedToUpdateMemberType,
}: MemberEmployeeStatusProps) => {
  const [updateMembership] = useUpdateMembership({
    refetchQueries: ['membership'],
  });

  if (member.membershipType === Membership_Type.RcUser) {
    return null;
  }

  const onMemberEmployeeTypeChange = (type: Membership_Type) => {
    updateMembership({
      variables: {
        input: {
          id: member.id,
          customerUuid: member.customerUuid,
          membershipType: type,
        },
      },
    });
  };

  return (
    <MemberTypeDropdown
      selectedType={member.membershipType || Membership_Type.Standard}
      onMemberEmployeeTypeChange={onMemberEmployeeTypeChange}
      isUserPermittedToUpdateMemberType={isUserPermittedToUpdateMemberType}
      selectedState={member.state}
    />
  );
};
